module.exports = __webpack_public_path__ + "static/media/logo-white.d5ef431a.png";